import { Box, Divider, Typography, Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./EventCard.styles";
import * as FaIcons from "react-icons/fa";

type TProps = {
  eventID?: string;
  eventName?: string;
};

const EventCard: React.FC<TProps> = ({ eventID, eventName }) => {
  const navigate = useNavigate();

  return (
    <Box sx={styles.container}>
      <Typography variant="overline" color="initial">
        {eventName}
      </Typography>
      <Divider sx={styles.divider} />
      <Box component="div" sx={styles.innerContainer}>
        <Button
          onClick={() => navigate(`/event-manager/edit/${eventID}`)}
          sx={styles.button}
          variant="contained"
          color="info"
          size="small"
          startIcon={<FaIcons.FaCalendarAlt size={10} />}
        >
          Esemény megtekintése
        </Button>
        <Button
          onClick={() => navigate(`/event-manager/edit/${eventID}/data`)}
          sx={styles.button}
          variant="contained"
          color="info"
          size="small"
          startIcon={<FaIcons.FaUserAlt size={10} />}
        >
          Vendéglista
        </Button>
        <Button
          onClick={() => navigate(`/event-manager/csv-export/${eventID}`)}
          sx={styles.button}
          variant="contained"
          color="info"
          size="small"
          startIcon={<FaIcons.FaFileCsv size={10} />}
        >
          CSV export
        </Button>
        <Button
          onClick={() => navigate(`/event-manager/csv-import/${eventID}`)}
          sx={styles.button}
          variant="contained"
          color="info"
          size="small"
          startIcon={<FaIcons.FaFileCsv size={10} />}
        >
          CSV import
        </Button>
        <Button
          href={`${process.env.REACT_APP_HOSTESS_VIEW_URL}${eventID}/event-manager`}
          target="_blank"
          sx={styles.button}
          variant="contained"
          color="info"
          size="small"
          startIcon={<FaIcons.FaLink size={10} />}
        >
          Hostess nézet
        </Button>
      </Box>
    </Box>
  );
};

export default React.memo(EventCard);
